module.exports = __webpack_public_path__ + "img/Vector_nav_graph.3b971bd7.svg";